import { Component, Injector } from '@angular/core';
import type { OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { addIcons } from 'ionicons';

import { ServiceAreasService } from '@shared/services';
import type { TServiceArea } from '@shared/models';
import { ViewBasePage } from '@shared/pages';
@Component({
    'selector': 'app-serviceAreas',
    'templateUrl': './serviceAreas.page.html',
    'styleUrls': ['./serviceAreas.page.scss'],
    'standalone': true,
    'imports': [ CommonModule, FormsModule, IonicModule ]
})
export class ServiceAreasPage extends ViewBasePage implements OnInit, OnDestroy {
    public areas: TServiceArea[];
    private subscription: any;
    public serviceAreasDefinedStr: string;

    constructor(private serviceAreasService: ServiceAreasService,  injector: Injector) {
        super(injector);
        addIcons({
            'one': 'assets/icons/one.png',
            'two-plus': 'assets/icons/two-plus.png'
        });
    }

    public ionViewWillEnter(): void {
        super.setCurrentView(this.Constants.VIEW_SERVICE_AREAS);
    }

    public override async ngOnInit(): Promise<void> {
        const observable = this.serviceAreasService.getObservable();
        this.subscription = observable.subscribe((areas: TServiceArea[]) => {
            this.areas = areas.sort((a, b) => {
                if (a.zipcode < b.zipcode) {
                    return -1;
                } else if (a.zipcode > b.zipcode) {
                    return 1;
                } else {
                    return 0;
                }
            });
            this.serviceAreasDefinedStr = this.utilsService.
                useSingularOrPlural(this.areas.length, 'service area defined.', 'service areas defined.');
            // this.initMoreMenu();

            // await this.uxHelperService.hideSpinner();
        });
    }

    public override ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    // public initMoreMenu(): void {
    //     this.pushPopoverMenuItem('Show Tour', 'show-service-areas-tour');
    // }

    public onServiceAreaSingleClick(uid: string): void {
        this.router.navigateByUrl(`/managerSettings/serviceAreas/serviceAreaSingle/${uid}`);
    }

    public onServiceAreaMultipleClick(): void {
        this.router.navigateByUrl(`/managerSettings/serviceAreas/serviceAreaMultiple`);
    }

    public async onAddClick(/* event: Event */) {
        // const options: PopoverOptions = {
        //     'component': PopoverMenu,
        //     'componentProps': { 'menuItems': ['Add Single Zipcode', 'Add Multiple Zipcodes'] },
        //     'event': event,
        //     'showBackdrop': true
        // };

        // const popover = await this.popoverController.create(options);
        // popover.onDidDismiss()
        // .then((response) => {
        //     if (response.data) {
        //         switch (response.data.selectedItem) {
        //             case 'Add Single Zipcode':
        //                 this.router.navigateByUrl('serviceAreaSingle');
        //                 break;

        //             case 'Add Multiple Zipcodes':
        //                 this.router.navigateByUrl('serviceAreaMultiple');
        //                 break;
        //         }
        //     }
        // });
        // popover.present();
    }

    // public onAddAreaClick() {
    //     this.navCtrl.push('ServiceAreaPage', { uid: '' });
    //     // this.openCheckboxModal({});
    // }

    // public onEditAreaClick(area) {
    //     // this.navCtrl.push('ServiceAreaPage', { uid: area.uid });
    //     this.navCtrl.push('ServiceAreaSinglePage', { uid: area.uid });
    // }

    public onBackClick(): void {
        this.router.navigateByUrl('/managerSettings');
    }

    public async confirmDeleteArea(area) {
        const data = area.zipcode + ' - ' + area.city;
        const question = 'Are you sure you want to delete: ' + data + '?';

        const response = await this.uxHelperService.showAlert('Confirm Delete', question);
        if (response.okay) {
            await this.uxHelperService.showSpinner('Deleting.');
            await this.serviceAreasService.delete(area.uid);
            await this.uxHelperService.hideSpinner();
            this.uxHelperService.showToast('Done.');
        }
    }
}
